import { Box, Button, Heading, Layer, Paragraph } from 'grommet';
import React from 'react';

export interface ConfirmModalProps {
  title: string;
  text: string;
  closable: boolean;
  confirmBtnText?: string;
  confirmBtnTitle?: string;
  closeBtnText?: string;
  closeBtnTitle?: string;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  onClose, closable, title, text, confirmBtnText, confirmBtnTitle, closeBtnText, closeBtnTitle, onConfirm,
}): JSX.Element => {
  const onCloseAction = (): void => {
    if (closable) onClose();
  };

  return (
    <Layer
      position="center"
      onClickOutside={onCloseAction}
      onEsc={onCloseAction}
      responsive={false}
      margin="small"
    >
      <Box
        width="large"
        pad="medium"
        fill="horizontal"
      >
        <Heading
          textAlign="center"
          level={3}
          fill
        >
          {title || 'Are you sure?'}
        </Heading>
        <Box
          width="large"
          align="center"
          justify="center"
        >
          <Paragraph textAlign="center" fill>
            {text || 'Are you sure you want to proceed with this action?'}
          </Paragraph>
        </Box>

        <Box
          fill="horizontal"
          as="footer"
          gap="small"
          direction="row"
          align="center"
          justify="center"
          pad={{
            top: 'medium',
            bottom: 'small',
          }}
        >
          <Button
            label={confirmBtnText || 'Confirm'}
            title={confirmBtnTitle || 'Confirm'}
            onClick={onConfirm}
            primary
          />

          <Button
            label={closeBtnText || 'Cancel'}
            title={closeBtnTitle || 'Cancel'}
            onClick={onClose}
            reverse
            secondary
          />
        </Box>
      </Box>
    </Layer>
  );
};

ConfirmModal.displayName = 'ConfirmModal';

export default ConfirmModal;
